import 'react-phone-input-2/lib/style.css';
import { classList } from '../../helpers/classList';
import { FormLabel } from '../FormLabel';
import { FieldError } from '../FieldError';
import styles from './PhoneInput.module.css';
import * as ReactPI from 'react-phone-input-2';

const ReactPhoneInput = ReactPI.default ?? ReactPI;

export interface PhoneInputProps extends ReactPI.PhoneInputProps {
  id?: string;
  name?: string;
  state?: 'normal' | 'valid' | 'error';
  required?: boolean;
  readOnly?: boolean;
  error?: string;
  className?: string;
  label?: string;
}

export const PhoneInput = ({
  id,
  name,
  state,
  readOnly,
  required,
  error,
  className,
  label,
  inputProps,
  ...restProps
}: PhoneInputProps) => {
  // possible visual states: ['normal' or undefined, 'valid', 'error']
  const stateResult = state && state != 'normal' ? state : undefined;

  return (
    <div className={className}>
      <FormLabel htmlFor={id} required={required}>
        {label}
      </FormLabel>
      <ReactPhoneInput
        country={'gb'}
        preferredCountries={['uk']}
        inputProps={{ ...inputProps, id, name, disabled: readOnly }}
        countryCodeEditable={false}
        // the country masks cut whatever does not fit them, silently losing a
        // digit; the API reads and validates the whole number instead (PPL-4147)
        enableLongNumbers
        containerClass={classList(
          styles['input-container'],
          stateResult ? styles[`input-container-${stateResult}`] : undefined,
        )}
        buttonClass={classList(
          styles['flag-container'],
          stateResult ? styles[`flag-container-${stateResult}`] : undefined,
        )}
        inputClass={classList(styles.input, stateResult ? styles[`input-${stateResult}`] : undefined)}
        {...restProps}
      />
      {error && <FieldError>{error}</FieldError>}
    </div>
  );
};
